import { db, ensureFirebaseAuth } from "../db";
import * as THREE from "three";

function parseSilentZoneData(data) {
  return {
    ...data,
    position: new THREE.Vector3(...data.position.split(",").map((x) => +x)),
    radiusDistance: new THREE.Vector3(0, 0, 0).distanceToSquared(
      new THREE.Vector3(data.radius, 0, 0)
    ),
  };
}

export default class SilentZones {
  constructor() {
    this.silentZones = [];
  }

  async load() {
    await ensureFirebaseAuth();

    db.collection("silentZones").onSnapshot((querySnapshot) => {
      const silentZones = [];

      querySnapshot.forEach((doc) =>
        silentZones.push(parseSilentZoneData(doc.data()))
      );

      this.silentZones = silentZones;
    });
  }

  getMaxVolume(playerPosition) {
    const activeZones = this.silentZones.filter(({ active }) => active);

    for (let i = 0; i < activeZones.length; i++) {
      const { position, radiusDistance, maxVolume } = activeZones[i];
      const distance = playerPosition.distanceToSquared(position);

      if (distance <= radiusDistance) return maxVolume;
    }

    return 1;
  }
}
